import { Route } from "react-router-dom";

import { AccountInvoice } from "src/pages/admin/invoice/AccountInvoice";
import { VIEW_ACCOUNT } from "src/constants";
import { ACCOUNT_ROUTES } from "src/pages/account/constants";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { Accounts } from "./Accounts.page";
import { SingleAccount } from "./SingleAccount.page";

/** Route tree for the account module, mounted under `/accounts` and `/account`. */
export const accountRoutes = (
  <>
    <Route path={ACCOUNT_ROUTES.root} element={<ProtectedRoute permissions={VIEW_ACCOUNT} component={Accounts} />} />
    <Route
      path={ACCOUNT_ROUTES.details}
      element={<ProtectedRoute permissions={VIEW_ACCOUNT} component={SingleAccount} />}
    />
    {/* TODO: TBD the permission for VIEW INVOICE or VIEW TRANSACTION */}
    <Route
      path={ACCOUNT_ROUTES.invoice}
      element={<ProtectedRoute permissions={VIEW_ACCOUNT} component={AccountInvoice} />}
    />
  </>
);
